// extracted by mini-css-extract-plugin
module.exports = {"pointsDisplay":"PointsDisplay_pointsDisplay__bhnqW","points":"PointsDisplay_points__u_rU2","currency":"PointsDisplay_currency__VL23i"};